import { off, on, popup } from '@telegram-apps/sdk-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useVideoDeleteConfirm = (onConfirmDelete: () => void) => {
  const { t } = useTranslation();
  const pendingRef = useRef(false);

  useEffect(() => {
    const handler = (payload: { button_id?: string }) => {
      if (payload.button_id === 'delete_video' && pendingRef.current) {
        onConfirmDelete();
        pendingRef.current = false;
      }

      if (payload.button_id === 'cancel') {
        pendingRef.current = false;
      }
    };

    on('popup_closed', handler);

    return () => {
      off('popup_closed', handler);
    };
  }, [onConfirmDelete]);

  return async () => {
    pendingRef.current = true;

    await popup.show({
      title: t('delete_video_title'),
      message: t('delete_video_message'),
      buttons: [
        {
          id: 'delete_video',
          type: 'destructive',
          text: t('delete_video_action_title')
        },
        {
          id: 'cancel',
          type: 'default',
          text: t('delete_video_cancel_title')
        }
      ]
    });
  };
};